<template>
  <div id="AssemblyList_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            區權會會議列表
          </div>
          <div class="tip">
            可檢視所有區權會會議的會議紀錄與會議狀態。
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-plus"
            round
            @click="$router.push({name: 'AssemblyEdit'})"
          >
            新增會議
          </el-button>
        </div>
      </div>
      <el-table :data="listData">
        <el-table-column
          type="index"
          align="center"
          width="50"
        />
        <el-table-column
          align="left"
          label="會議標題"
          min-width="150"
        >
          <template slot-scope="scope">
            <span
              class="title"
              @click="$router.push({name:'AssemblyDetail', params: { id: scope.row.id }})"
            >{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="assemblyDate"
          align="left"
          label="會議日期"
        />
        <el-table-column
          align="left"
          label="會議類別"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.category == 'Regular'">
              定期會議
            </p>
            <p v-if="scope.row.category == 'Extraordinary'">
              臨時會議
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateDate"
          align="left"
          label="會議狀態"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.status == 'Deleted'">
              已刪除
            </p>
            <p v-if="scope.row.status == 'Cancelled'">
              已取消
            </p>
            <p v-if="scope.row.status == 'Created'">
              已建立
            </p>
            <p v-if="scope.row.status == 'Published'">
              已發佈
            </p>
            <p v-if="scope.row.status == 'ThresholdMet'">
              已發佈
            </p>
            <p v-if="scope.row.status == 'Started'">
              已開始
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作"
          min-width="150"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="scope.row.status == 'Created'"
              plain
              @click="$router.push({name: 'AssemblyRegister', params: { id: scope.row.id }})"
            >
              報到
            </el-button>
            <el-button
              size="mini"
              plain
              @click="print(scope.row.id, scope.row.title)"
            >
              列印
            </el-button>
            <el-button
              size="mini"
              plain
              @click="$router.push({name: 'UnitOwnerList', params: { id: scope.row.id }})"
            >
              出席名單
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
      <PrintDialog ref="PrintDialog" />
    </div>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import PrintDialog from './components/print/PrintDialog'

export default {
  components: {
    PrintDialog,
    TableLoading
  },
  data () {
    return {
      listData: [],
      loading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      apiUnitOwnerAssembly.GetAssemblyList().then(res => {
        if (res.status === 200) {
          this.listData = res.data
        }
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 開啟列印彈窗
    print (assemblyId, title) {
      this.$refs.PrintDialog.openPrintDialogFromList(assemblyId, title)
    },
    // 建立會議
    creatAssembly () {
      this.$router.push({ name: 'AssemblyEdit' })
    },
    goDetailPage (id) {
      this.$router.push({ name: 'AssemblyEdit', query: { id } })
    }
  }
}
</script>

<style lang="sass" scoped>
#AssemblyList_main
  +mainLayer
  ::v-deep .el-table
    +basicTable
    font-size: 15px
    .title
      cursor: pointer
      color: $mainColor
      border-bottom: $mainColor 1px solid
      margin-bottom: 1px

</style>
